// UI strings of the loading screen's warm-up (shell/warmup/, shown by shell/UpdateGate.tsx): one
// status line per step (a step's `label` is a key here). Only the state, no explanation.
import { defineArea } from '../area';

export const warmupFi = {
  dictionary: 'Valmistellaan sanakirjaa…',
  lines: 'Valmistellaan sarjan repliikkejä…',
  sections: 'Ladataan osioita…',
  grammar: 'Valmistellaan kielioppia…',
  /** The progress line's spoken name. */
  progress: 'Sovellus käynnistyy',
};

export const warmupEn: typeof warmupFi = {
  dictionary: 'Preparing the dictionary…',
  lines: 'Preparing the show lines…',
  sections: 'Loading the sections…',
  grammar: 'Preparing the grammar…',
  progress: 'The app is starting',
};

// Messages.warmup (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('warmup', warmupFi, warmupEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof warmupFi> {}
}
